import { Translation, required } from '@ps/web-shared-components';
import React, { useEffect } from 'react';
import { useField } from 'react-final-form';

import countries from '@swf/generated/countries.json';

import CountrySelect from '../../../../../CountrySelect/CountrySelect';
import RMFDropDown from '../../../RMFDropDown/RMFDropDown';

import {
  TXTCLI_Citizenship,
  TXTCLI_Please_select_your_citizenship
} from './SelectCitizenship.messages.json';

interface Props {
  handleRomanianCitizenship(): void;
}

const SelectCitizenship: React.FC<Props> = ({ handleRomanianCitizenship }) => {
  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true } });

  useEffect(() => {
    if (citizenship === 'RO') handleRomanianCitizenship();
  }, [citizenship, handleRomanianCitizenship]);

  return (
    <CountrySelect name="citizenship" title={TXTCLI_Citizenship}>
      <RMFDropDown
        id="citizenship"
        options={countries}
        label={TXTCLI_Citizenship}
        validators={[required(null)]}
        placeholder={<Translation {...TXTCLI_Please_select_your_citizenship} />}
      />
    </CountrySelect>
  );
};

export default SelectCitizenship;
